type ZendeskWidget = (action: 'webWidget', command: string, payload?: unknown) => void;

const getZendeskWidget = () => (window as typeof window & { zE?: ZendeskWidget }).zE;

export const showZendeskWidget = () => getZendeskWidget()?.('webWidget', 'show');

export const hideZendeskWidget = () => getZendeskWidget()?.('webWidget', 'hide');

export const updateZendeskWidgetSettings = (settings: unknown) =>
	getZendeskWidget()?.('webWidget', 'updateSettings', settings);
